const items = ["Faith in God", "Family", "Customers First", "Integrity", "Stewardship", "Compassion"];

export const EditorialMarquee = () => {
  const content = [...items, ...items, ...items];

  return (
    <section data-testid="values-marquee" className="marquee border-y border-border bg-muted/70 py-5">
      <div className="marquee-track items-center gap-20 pr-20">
        {content.map((item, index) => (
          <span
            key={`${item}-${index}`}
            className="flex items-center gap-20 font-serif text-xl italic tracking-wide text-primary/70 md:text-2xl"
          >
            {item}
            <span className="h-1.5 w-1.5 rounded-full bg-secondary" aria-hidden="true" />
          </span>
        ))}
      </div>
    </section>
  );
};
